module.exports = __webpack_public_path__ + "img/tc.c230211e.svg";